import { createStore } from 'vuex'
import { normalizeWorkspace, type Workspace } from '@/constants/workspaces'

// A lista de áreas e a migração das chaves antigas vivem em
// @/constants/workspaces — aqui só a persistência.
const WORKSPACE_KEY = 'currentWorkspace'

function loadWorkspace(): Workspace {
  try {
    const raw = localStorage.getItem(WORKSPACE_KEY)
    const next = normalizeWorkspace(raw)
    // Regrava o valor já migrado. Sem isso a chave antiga fica no navegador
    // para sempre e o mapa de migração nunca pode ser removido — e esta chave
    // já mudou de nome mais de uma vez.
    if (raw !== null && raw !== next) localStorage.setItem(WORKSPACE_KEY, next)
    return next
  } catch (e) {
    return 'crm'
  }
}

const store = createStore({
  state: {
    successMessage: null,
    errorMessage: null,
    isSidebarMinimized: false,
    userName: 'User Name',
    currentWorkspace: loadWorkspace() as Workspace,
  },
  mutations: {
    toggleSidebar(state) {
      state.isSidebarMinimized = !state.isSidebarMinimized
    },
    setSuccessMessage(state, message) {
      state.successMessage = message
    },
    setErrorMessage(state, message) {
      state.errorMessage = message
    },
    clearMessages(state) {
      state.successMessage = null
      state.errorMessage = null
    },
    setWorkspace(state, workspace: Workspace) {
      const next: Workspace = normalizeWorkspace(workspace)
      state.currentWorkspace = next
      try {
        localStorage.setItem(WORKSPACE_KEY, next)
      } catch (e) {
        /* ignore */
      }
    },
  },
  actions: {
    clearMessages({ commit }) {
      commit('clearMessages')
    },
  },
  modules: {},
})

export default store
